import useLoginMutation from '@apis/mutations/useLoginMutation';
import { isTestEnv } from '@functions/functions';
import { EToastVariant } from '@notifications/components/Toast/Toast.enum';
import { captureException } from '@sentry/nextjs';
import useAddToast from '@store/toastsStore/hooks/useAddToast';
import { EToastUUID } from '@store/toastsStore/toastsStore.enum';
import { APP_LINKS } from '@utils/variables';
import { useCallback } from 'react';
import { ERROR } from 'src/texts/feedbackMessages';

export default function useLogin() {
	const { addToast } = useAddToast();
	const { login: loginMutation } = useLoginMutation();

	const login = useCallback(async () => {
		try {
			const width = 450;
			const height = 600;
			const left = window.screen.width / 2 - width / 2;
			const top = window.screen.height / 2 - height / 2;

			// we override the github login process in cypress
			if (isTestEnv()) {
				loginMutation('cypress-env');
				return;
			}

			window.open(
				APP_LINKS.auth.href,
				'github-window',
				'menubar=no, toolbar=no, location=no, status=no, width=' +
					width +
					', height=' +
					height +
					', top=' +
					top +
					', left=' +
					left +
					',max-width=100%,max-height=100%'
			);
		} catch (err) {
			console.error('login', err);

			addToast({
				uuid: EToastUUID.errorConnectingWallet,
				variant: EToastVariant.error,
				title: ERROR.genericToastTitle,
				message: ERROR.auth.connectingWallet,
				rawError: err
			});

			captureException(err);
		}
	}, [addToast, loginMutation]);

	return { login };
}
